export default "__VITE_PUBLIC_ASSET__14ebbbad__"